import ScrollTop from "./ScrollTop";
// import SideBox from "./SideBox.js";
import Content from "../components/ContentHeader";
import Route from "../components/Route";
// import { Link, NavLink } from "react-router-dom";

// css
import "../css/AiSolutionPage.css";

//img
import buttonArrow from "../assets/img/button_arrow_icon.png";
import aiIcon2 from "../assets/img/ai_icon2.png";
import aiIcon3 from "../assets/img/ai_icon3.png";
import aiIcon4 from "../assets/img/ai_icon4.png";

const data = [
  {
    icon: aiIcon3,
    heading: "EurekaGenAI",
    description:
      "유레카GenAI는 기업이 보유한 문서와 지식을 기반으로 지식베이스를 구축하고, 검색 증강 생성(Retrieval-Augmented Generation, RAG) 기술을 적용하여 도메인 전문성을 갖춘 고품질의 기업 특화 생성형 AI 서비스를 제공합니다.",
    button1: "소개 페이지 바로가기",
    button2: "소개 자료 보기",
    link1: "https://rbrain.co.kr/business/eurekagenai",
    link2:
      "http://file.rbrain.co.kr/2025-10-17T07-07-01-614Z-%EC%9C%A0%EB%A0%88%EC%B9%B4RAG%28%EA%B2%80%EC%83%89%EC%A6%9D%EA%B0%95%EC%83%9D%EC%84%B1_AI%EC%86%94%EB%A3%A8%EC%85%98%29_%EC%86%8C%EA%B0%9C_v1.5.pdf",
  },
  {
    icon: aiIcon4,
    heading: "Trend Sensing Board",
    description:
      "고객이 효과적으로 트렌드 분석을 하기 위해 데이터 시각화를 제공하여 데이터 기반의 수준 높은 비즈니스 결정을 지원하는 ‘트렌드 자동화 솔루션’ 입니다.",
    button1: "소개 페이지 바로가기",
    button2: "서비스 체험하기",
    link1: "https://rbrain.co.kr/business/trend",
    link2: "https://tsb.today/",
  },
  {
    icon: aiIcon2,
    heading: "EurekaBrain",
    description:
      "커머스 시장에서 소비재 브랜드가 지속적으로 선재 대응할 수 있도록 데이터를 빠르게 수집하고 분석 및 대응을 자동화할 수 있는 '데이터 자동화 솔루션' 입니다.",
    button1: "소개 페이지 바로가기",
    button2: "",
    link1: "https://rbrain.co.kr/business/eureka",
    link2: "",
  },
];

function AiSolutionPage() {
  return (
    <div className="ai_solution_page">
      <ScrollTop />

      <Content title="AI SOLUTION" title1=""></Content>

      <Route route1="BUSINESS" route2="AI SOLUTION"></Route>
      <div className="content_bg">
        <h1>생성형 AI · RAG · RPA 기술로 실현하는 스마트 업무 자동화 솔루션</h1>
        <div className="container">
          {data.map((item, index) => (
            <div className={`page_box cont${index + 1}`} key={index}>
              <div className="icon_img">
                <img src={item.icon} alt="아이콘 이미지" />
              </div>

              <div className="text_box">
                <h2 className="heading2">{item.heading}</h2>
                <p className="contents1">{item.description}</p>
                <div>
                  <a
                    href={item.link1}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="blue_btn button1">
                      {item.button1}
                      <img src={buttonArrow} alt="바로가기 버튼" />
                    </button>
                  </a>

                  {/* 다음 버튼이 있는 경우에만 렌더링 */}
                  {item.button3 && (
                    <a
                      href={item.link3}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="blue_btn button3">
                        {item.button3}
                        <img src={buttonArrow} alt="바로가기 버튼" />
                      </button>
                    </a>
                  )}

                  {item.button2 && (
                    <a
                      href={item.link2}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="blue_btn button2">
                        {item.button2}
                        <img src={buttonArrow} alt="바로가기 버튼" />
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AiSolutionPage;
